<template>
    <div>
        <Banner />
        <section class="aboutBox">
            <div class="aboutBox_rightimg">
                <img :src="$root.$TEMP_URL+homeAbout.ico" />
            </div>
            <div class="about_wordBox">
                <div class="wrapper">
                   <div class="about_word">
                       <div class="titleBox">
                          <div class="title wow slideInUp" data-wow-duration="1s" data-wow-delay="200ms" >{{isZhong?'关于我们':'ABOUT US'}}</div>
                          <div class="more">
                              <router-link to="/about/profile">
                                  {{isZhong?'更多':'Read More'}} <span>+</span>
                              </router-link>
                          </div>

                       </div>
                       <div class="descSmall wow slideInUp" data-wow-duration="1s" data-wow-delay="200ms" >
                           {{homeAbout.description}}
                       </div>
                       <div class="descBig wow slideInUp" data-wow-duration="1s" data-wow-delay="200ms" ref="homeAboutContent"  ></div>
                   </div>

                </div>
            </div>
        </section>

        <section class="entCultureBox">
            <div class="wrapper">
                <div class="entCulture">
                    <div class="entCulture_title wow slideInLeft">
                        <router-link to="/about/culture">{{isZhong?'企业文化':'ENTERPRISE CULTURE'}}</router-link>
                    </div>
                    <div class="entCulture_iconList">

                        <div class="entCulture_iconItem">
                            <div class="iconItemImg">
                                <img src="./images/about01.png" />
                            </div>
                            <div class="iconItemText wow slideInUp" data-wow-duration="1s" data-wow-delay="200ms" v-html="isZhong?lableInfo.culture1cn:lableInfo.culture1">
                               
                            </div>
                        </div>
                        <div class="entCulture_iconItem">
                            <div class="iconItemImg">
                                <img src="./images/about02.png" />
                            </div>
                            <div class="iconItemText wow slideInUp" data-wow-duration="1s" data-wow-delay="200ms" v-html="isZhong?lableInfo.culture2cn:lableInfo.culture2">
                                
                            </div>
                        </div>
                        <div class="entCulture_iconItem">
                            <div class="iconItemImg">
                                <img src="./images/about03.png" />
                            </div>
                            <div class="iconItemText wow slideInUp" data-wow-duration="1s" data-wow-delay="200ms" v-html="isZhong?lableInfo.culture3cn:lableInfo.culture3">
                                
                            </div>
                        </div>
                        <div class="entCulture_iconItem">
                            <div class="iconItemImg">
                                <img src="./images/about04.png" />
                            </div>
                            <div class="iconItemText wow slideInUp" data-wow-duration="1s" data-wow-delay="200ms" v-html="isZhong?lableInfo.culture4cn:lableInfo.culture4">
                                
                            </div>
                        </div>
                        <div class="entCulture_iconItem">
                            <div class="iconItemImg">
                                <img src="./images/about05.png" />
                            </div>
                            <div class="iconItemText wow slideInUp" data-wow-duration="1s" data-wow-delay="200ms" v-html="isZhong?lableInfo.culture5cn:lableInfo.culture5">
                              
                            </div>
                        </div>

                    </div>
                </div>
            </div>
        </section>
        <section class="productBox">
            <div class="wrapper">
                <div class="product">
                    <div class="product_title">
                        <router-link to="/products">{{isZhong?'产品展示':'PRODUCTS'}}</router-link>
                    </div>
                    <div class="product_list" v-if="productArr && productArr.length>0">

                        <div class="productListItem" :class="{active:item.isActive}" v-for="item in productArr" :key="item.id" @mouseenter.stop="changeProClass(item.id)">
                            
                            <router-link :to="`/products/productlist/${item.id}`">
                                <img :src="$root.$TEMP_URL+item.ico" />   
                                <div class="title">
                                    {{item.name}}  
                                </div> 
                            </router-link>
                        </div>

                    </div>
                </div>
            </div>
        </section>

        <section class="newsBox">
            <div class="wrapper">
                <div class="news">
                    <div class="newsTitleBox">
                        <div class="title wow slideInUp" data-wow-duration="1s" data-wow-delay="200ms">
                            <router-link to="/news">{{isZhong?'新闻中心':'NEWS'}}</router-link>
                        </div>
                        <div class="more">
                            <router-link to="/news">
                                {{isZhong?'更多':'Read More'}} <span>+</span>
                            </router-link>
                        </div>
                    </div>
                    <div class="newsCenBox">
                        <div class="newsImg">
                            <router-link  :to="`/news/newsdetail/${recommendNews.id}`" >
                                <img :src="$root.$TEMP_URL+recommendNews.ico" />
                                <div class="newsImgTitle">
                                    <div class="title">{{recommendNews.title}}</div>
                                    <div class="date" v-if="recommendNews.date">{{recommendNews.date.slice(0,7)}}</div>
                                </div>
                            </router-link >
                            
                        </div>
                        <div class="newsList" >
                            <router-link :to="`/news/newsdetail/${item.id}`" v-for="item in topNews" :key="item.id">
                                <div class="newsListItem wow slideInUp" data-wow-duration="1s" data-wow-delay="200ms">
                                    <div class="date" v-if="item.date">
                                        <!-- {{item.date}} -->
                                        <div class="day">{{item.date.slice(8,10)}}</div>
                                        <div class="month">{{item.date.slice(0,7)}}</div>
                                    </div>
                                    <div class="title">
                                        {{item.title}}
                                    </div>
                                </div>
                            </router-link>

                        </div>
                    </div>
                </div>
            </div>
        </section>

        <section class="indexMapBox" :class="{mapen:isZhong}">
            <div class="wrapper">
                <div class="indexMapItem">
                    <div class="ico">
                        <img src="./images/adress_def.png" />
                    </div>
                    <div class="name wow slideInUp" data-wow-duration="1s" data-wow-delay="200ms">Address</div>
                    <div class="desc wow slideInUp" data-wow-duration="1s" data-wow-delay="200ms">
                        {{isZhong?lableInfo.cnAddress:companyInfo.address}}
                    </div>
                </div>
                <div class="indexMapItem">
                    <div class="ico">
                        <img src="./images/tel_def.png" />
                    </div>
                    <div class="name wow slideInUp" data-wow-duration="1s" data-wow-delay="200ms">Phone</div>
                    <div class="desc wow slideInUp" data-wow-duration="1s" data-wow-delay="200ms">
                        {{companyInfo.phone}}
                    </div>
                </div>
                <div class="indexMapItem">
                    <div class="ico">
                        <img src="./images/email_def.png" />
                    </div>
                    <div class="name wow slideInUp" data-wow-duration="1s" data-wow-delay="200ms">Email</div>
                    <div class="desc wow slideInUp" data-wow-duration="1s" data-wow-delay="200ms">
                        {{companyInfo.email}}
                    </div>
                </div>
            </div>
        </section>


    </div>
</template>

<script>
import Vue from 'vue'
import VueCookies from 'vue-cookies'
Vue.use(VueCookies)
import Banner from '../../components/Banner/Banner';
import { 
    getHomeAbout,
    getLable,
    getHomeRecNews,
    getHomeTopNews,
    getCompany,
    getProductNav,
    getHomeAboutcn,
    getProductNavcn,
    getHomeRecNewscn,
    getHomeTopNewscn
     
} from '../../api'
import bus from '../../../static/js/eventBus'

export default {
    data(){
        return {
            homeAbout:{},
            homeAboutContent:'',
            lableInfo:{},
            productArr:[],
            recommendNews:{},   //首页推荐新闻，数组里有1条
            topNews:[],          //首页top新闻，数据里有3条
            companyInfo:{},
            isZhong:false
        }
    },
   components:{
       Banner
   },
   async created(){
       this._initHomeAll()
   },
   methods:{
     
      changeProClass(id){
          const productArr = this.productArr;
          const index = productArr.findIndex(v=>v.id === id);
          productArr.forEach(v=>v.isActive=false);
          productArr[index].isActive = true;
      },
      //初始化首页数据
      async _initHomeAll(){
            const language = this.$cookies.get('language');
            let isZhong;
			if(language==="zhong"){
				isZhong = true;
			}else{
				isZhong = false;
			}
            this.isZhong = isZhong;
            
            //关于我们
            let res;
            let productArr = [];
            let respro;
            let resNews;
            let topNews;


            if(isZhong){
               res = await getHomeAboutcn();
               respro = await getProductNavcn();
               resNews = await getHomeRecNewscn();
               topNews = await getHomeTopNewscn();

            }else{
               res = await getHomeAbout();
               respro = await getProductNav();
               resNews = await getHomeRecNews();
               topNews = await getHomeTopNews();
            }    
            const homeAbout = res.data;
            this.homeAbout = homeAbout;
            let  homeAboutContent = homeAbout.content;
            this.$refs.homeAboutContent.innerHTML =  homeAboutContent;

            //自定义标签
            const resLab = await getLable();
            const lableInfo = resLab.data;
            this.lableInfo =lableInfo;

            //推荐新闻
            this.recommendNews = resNews.data[0];
            //top新闻
            this.topNews = topNews.data;

            //公司信息
            const companyInfo = await getCompany();
            this.companyInfo = companyInfo.data;
            
            productArr = respro.data.map(v=>{
                    return{
                        name:v.name,
                        id:v.scode,
                        ico:v.ico,
                        isActive:false
                    } 
                })
            //处理分类  
            productArr[0].isActive = true;
            this.productArr =productArr;
      }
   },
   mounted() {
   	// new  this.$wow.WOW().init()
   },
   watch:{
      productArr(value) {
            console.log(value,1)
            this.$nextTick(() => { // 在dom渲染完后,再执行动画
                var wow = new  this.$wow.WOW({
                    live: false
                })
                setTimeout(()=>{
                     wow.init()
                },200)
            })
      }
   }
};
</script>
<style lang="scss" scoped>
@import '../../common/css/mixin.scss';
.aboutBox {
   margin: 86px 0 0 0;
   padding: 0 0 66px 0;
   background: url(./images/about-us_beijing_def.png) no-repeat;
   display: flex;
   position: relative;
   justify-content: flex-end;
  .aboutBox_rightimg {
     width: 50%; 
     overflow: hidden;
    img {
        width: 100%;
        height: 475px;
        @include compatible(transition,all 1s);
    }
    &:hover{
        img{
          @include compatible(transform,scale(1.1));
        }
    }
  }

  .about_wordBox {
    position:absolute;
    left: 0;
    top: 0;
    width: 100%;
    .wrapper {
       position: relative;
       z-index: 2;
      .about_word {
        margin-top: 66px;
        width: 58%;
        height: 409px;
        overflow: hidden;
        @include boxSizing;
        padding: 26px 0 18px 0;
        .titleBox {
          height: 44px;
          @include flexFather;
          .title {
              font-size: 30px;
              color: $themeColor;
              font-weight: bold;
          }

          .more {
              margin-right: 22px;
              a{
                //   font-size: 12px;
                  span{
                      color: red;
                      font-size: 17px;
                  }
              }

          }

        }
        .descSmall {
            font-size: 18px;
            line-height: 32px;
            color: $themeColor;
            margin-bottom: 28px;
            padding-right: 72px;
            margin-top: 4px;
        }
        .descBig {
            line-height: 30px;
            padding-right: 72px;
        }

       

      }
      //wrapper::before
      &::before{
        content: '';
        width: 8%;
        background: #fff;
        height: 100%;
        left: 50%;
        top: 0;
        position: absolute;
        z-index: -1;
            
      }
    }
     
  }
}
.entCultureBox {
   margin-bottom: 66px;
  .wrapper {
    .entCulture {
      @include flexFather;
      .entCulture_title {
        width: 260px;  
        height: 182px;
        color: #fff;
        font-size: 34px;
        font-weight: bold;
        background: $themeColor;
        display: flex;
        align-items: center;
        @include boxSizing;
        line-height: 52px;
        padding:0 14px;
        margin-right: 22px;
        a{
            color: #fff;
        }
      }
      .entCulture_iconList {
        flex: 1;
        display: flex;
        justify-content: space-around;
        .entCulture_iconItem {
          .iconItemImg {
            img {
                width: 75px;
                height: 75px;
            }
          }
          .iconItemText {
            margin-top: 12px;
            line-height: 28px;
            height: 56px;
            overflow: hidden;
          }
        }
      }
    }
  }
}

.productBox {
  padding: 66px 0 88px 0;
//   background: url(./images/product_beijing_def.jpg) no-repeat;
//   background-size: cover;
  background: #f4f4f4;
  .wrapper {
    .product {
      .product_title {
        margin-bottom: 28px;
        a {
            line-height: 62px;
            color:$themeColor;
            font-size: 34px;
            font-weight: bold;
        }
      }
      .product_list {
        display: flex;      
        .productListItem {
          width: 216px;  
          height: 486px;
          overflow: hidden;
          @include compatible(transition,all 0.6s) ;
          a {
            display: block;
            position: relative;
            height: 100%;
            img {
                max-width: inherit;
            }
            .title {
                position: absolute;
                @include boxSizing;
                padding: 0 12px;
                line-height: 32px;
                font-size: 18px;
                color: #fff;
                font-weight: bold;
                left: 0;
                top: 100px;
                text-align: center;
                width: 100%;
                &::after{
                    content: '';
                    position: absolute;
                    bottom: -18px;
                    left: 50%;
                    margin-left: -28px;
                    width: 56px;
                    height: 3px;
                    background: #fff;
                    
                }
                
            }
            &::before{
                content: '';
                position: absolute;
                width: 100%;
                height: 100%;
                top: 0;
                left: 0;
                background: rgba(0, 0, 0, 0.5);
            }

          }
          &.active{
            //  flex: 1;   
             width: 868px;
             a{
                 img{
                    //  max-width: 100%;
                 }
                 .title{
                    text-align: left;
                    top: 50px;
                    left: 38px;
                    padding: 0;
                    &::after {
                        left: 0;
                        margin-left: 0;
                    }
                 }
                 &::before{
                    // background: rgba(0,0,0,0.5);
                    // background: linear-gradient(to bottom right, rgba(0, 0, 0, 0.5) , rgba(0, 0, 0, 0));
                    background: url(./images/probg.png) no-repeat;
                    background-size: cover;
                 }
             }

          }

        }
      }
    }
  }
}

.newsBox {
  padding: 66px 0 88px 0;
  .wrapper {
    .news {
      .newsTitleBox {
        height: 62px;
        @include flexFather;
        align-items: center;
        margin-bottom: 28px;

        .title {
            a {
                line-height: 62px;
                color:$themeColor;
                font-size: 34px;
                font-weight: bold;
            }
        }

        .more {
          margin-right: 22px;
          a {
            span {
                color: red;
                font-size: 17px;
            }
          }
        }
      }

      .newsCenBox {
        @include flexFather;
        align-items: flex-start;  
        .newsImg {
          width: 620px;
          a {
            display: block;
            position: relative;
            overflow: hidden;
            img {
                width: 100%;
                height: 466px;
                @include compatible(transition,all 1s);
            }
            &:hover{
                img{
                   @include compatible(transform,scale(1.1));
                }
            }

            .newsImgTitle {
              position: absolute;  
              height: 60px;
              @include flexFather;
              background: rgba(0, 0, 0, 0.4);
              width: 100%;
              left: 0;
              bottom: 0;
              padding: 0 14px 0 16px;
              @include boxSizing;
              .title {
                  font-size: 20px;
                  color: #fff;
                  height: 60px;
                  line-height: 60px;
                  width: 82%;
              }
              .date {
                  font-size: 12px;
                  color: #fff;
              }
            }
          }
        }
        .newsList {
          width: 620px;
          .newsListItem {
            padding: 44px 26px 44px 26px;
            @include flexFather;
            .date {
              margin-right: 26px;
              .day {
                  color: #777;
                  font-size: 36px;
                  font-weight: bold;
                  text-align: center;
                  margin-bottom: 6px;
              }
              .month {
                  color: #777;
                  font-size: 12px;
                  text-align: center;
              }
            }
            .title {
                flex: 1;
                line-height: 28px;
                font-size: 16px;
                height: 56px;
                overflow: hidden;
            }
            &:hover{
                background: #f8f8f8;
                .day {
                  color: red;
                }
                .month {
                    color: red;
                }
            }
          }
        }
      }
    }
  }
}

.indexMapBox {
   background: url(./images/mapen.png) no-repeat; 

   background-size: cover;
   height: 400px;
   display: flex;
   align-items: flex-end;
  .wrapper {
     @include flexFather;
     justify-content: space-around; 
     background: #fff;
     height: 300px;
    .indexMapItem {
       width: 322px;
      .ico {
        text-align: center;
        img {
            display: inline-block;
        }
      }

      .name {
        text-align: center;
        margin: 18px 0;
      }

      .desc {
        text-align: center;
        font-size: 16px;
        line-height: 26px;

      }
    }
  }
  &.mapen{
      background: url(./images/mapcn.png) no-repeat; 
      background-size: cover;

  }
}


@media screen and (max-width: 1399px) {
   .aboutBox[data-v-3bf6d6bb] {
           background: url(./images/about-us_beijing_def.png)  center left  no-repeat;

        background-size: 50%;
   }
   
}

</style>


// WEBPACK FOOTER //
// src/pages/Home/Home.vue